/**
 * @Autor ITI Fernando FH
 * @Fecha martes, 21 de diciembre 2021.
 */

 import ServicePath from "@/core/ServicePath";
 import {
     MainRequest
 } from "@/core/request";
 
 export default class CancelledRequest extends MainRequest {
 
     static listAllCancelledStudy(data) {
         return this.postSEC(ServicePath.CANCELLED_STUDY, data)
     }
 
    static listAllCancelledMedicalPractice(data) {
        return this.postSEC(ServicePath.CANCELLED_MEDICAL_PRACTICE, data)
    }

    static listAllCancelledAppointment(data) {
        return this.postSEC(ServicePath.CANCELLED_APPOINTMENT, data)
    }

    static listAllCancelledPrescription(data) {
        return this.postSEC(ServicePath.CANCELLED_PRESCRIPTION, data)
    }

    static updateStatusListMedicalPractice(data){
        return this.postSEC(ServicePath.UPDATE_STATUS_LIST_MEDICAL_PRACTICE, data)
    }
    static updateStatusListAppointment(data){
        return this.postSEC(ServicePath.UPDATE_STATUS_LIST_APPOINTMENT, data)
    }
    static updateStatusListStudy(data){
        return this.postSEC(ServicePath.UPDATE_STATUS_LIST_STUDY, data)
    }
    static updateStatusListPrescription(data){
        return this.postSEC(ServicePath.UPDATE_STATUS_LIST_PRESCRIPTION, data)
    }
     
 
 }
 